import React, { ReactNode } from 'react';

type SummaryDesktopProps = {
    border?: boolean;
    className?: string;
    children: ReactNode;
};

export const SummaryDesktop: React.FC<SummaryDesktopProps> = ({ className, children }) => {
    return <div className={className}>{children}</div>;
};
